import { render, staticRenderFns } from "./ModalPageRenderer.vue?vue&type=template&id=493ad5fc&scoped=true&"
import script from "./ModalPageRenderer.vue?vue&type=script&lang=js&"
export * from "./ModalPageRenderer.vue?vue&type=script&lang=js&"
import style0 from "./ModalPageRenderer.vue?vue&type=style&index=0&id=493ad5fc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493ad5fc",
  null
  
)

export default component.exports